import React from 'react';
import styled from 'styled-components';
import Label from '../Label/Label';

const FieldLabelWrap = styled.div`
  .field-information-stat {
    display: flex;
    align-items: center;
    margin-top: ${({ theme }) => theme.spacing01};
    svg {
      margin-right: ${(props) => props.theme.spacing01};
      font-size: 30px;
      color: ${({ theme }) => theme.colorPrimary70};
    }
    :nth-child(2) {
      svg {
        font-size: 24px;
      }
    }
  }
`;

export default function FieldLabel({ label, icon, value }) {
  return (
    <FieldLabelWrap className="field-information-stat-wrap">
      <Label>{label}</Label>
      <div className="field-information-stat">
        {icon}
        <div className="fields-information-text">{value}</div>
      </div>
    </FieldLabelWrap>
  );
}
